import { render, staticRenderFns } from "./PortfolioName.vue?vue&type=template&id=0619beac&scoped=true&"
import script from "./PortfolioName.vue?vue&type=script&lang=ts&"
export * from "./PortfolioName.vue?vue&type=script&lang=ts&"
import style0 from "./PortfolioName.vue?vue&type=style&index=0&id=0619beac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0619beac",
  null
  
)

export default component.exports